export enum TrustLevel {
  User = 100,
  UserWithTicker = 110,
  Vereinsverwalter = 200,
  RegionsAdmin = 800,
  SuperAdmin = 900,
}
